import React from "react";
import PropTypes from "prop-types";
import { BOX_SIZE } from "../../../../constants/index";

const Direction = ({ x, y, cell }) => {
  const dx = x * BOX_SIZE;
  const dy = y * BOX_SIZE;

  const arrow =
    "horizontal" in cell ? (
      <svg x={dx - 7.5 + BOX_SIZE} y={dy - 7.5 + BOX_SIZE / 2}>
        <circle cx="7.5" cy="7.5" r="7.5" fill="#d41c5c" />
        <polygon
          points="12.73 7.5 6.93 2.85 6.93 5.45 3.48 5.45 3.48 9.54 6.93 9.54 6.93 12.14 12.73 7.5"
          fill="#fff"
        />
      </svg>
    ) : (
      <svg x={dx - 7.5 + BOX_SIZE / 2} y={dy - 7.5 + BOX_SIZE}>
        <circle cx="7.5" cy="7.5" r="7.5" fill="#d41c5c" />
        <polygon
          points="7.5 12.73 12.14 6.93 9.54 6.93 9.54 3.48 5.45 3.48 5.45 6.93 2.85 6.93 7.5 12.73"
          fill="#fff"
        />
      </svg>
    );

  return (
    <g data-x={x} data-y={y}>
      {arrow}
    </g>
  );
};

Direction.defaultProps = {
  x: 0,
  y: 0,
  cell: {}
};

const dataType = PropTypes.shape({
  text: PropTypes.string,
  image: PropTypes.string
});

Direction.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  cell: PropTypes.shape({
    horizontal: dataType,
    vertical: dataType
  })
};

export default Direction;



// WEBPACK FOOTER //
// ./src/components/Cells/Cells/Direction/Direction.js